module.exports = __webpack_public_path__ + "static/media/foodie_text.dbbb7cca.png";